
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_6eu0b_103",
  "root": "awsui_root_p8a6i_6eu0b_139",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_6eu0b_181",
  "header-refresh": "awsui_header-refresh_p8a6i_6eu0b_181",
  "list": "awsui_list_p8a6i_6eu0b_190",
  "list-grid-1": "awsui_list-grid-1_p8a6i_6eu0b_201",
  "card": "awsui_card_p8a6i_6eu0b_103",
  "list-grid-2": "awsui_list-grid-2_p8a6i_6eu0b_204",
  "list-grid-3": "awsui_list-grid-3_p8a6i_6eu0b_207",
  "list-grid-4": "awsui_list-grid-4_p8a6i_6eu0b_210",
  "list-grid-5": "awsui_list-grid-5_p8a6i_6eu0b_213",
  "list-grid-6": "awsui_list-grid-6_p8a6i_6eu0b_216",
  "list-grid-7": "awsui_list-grid-7_p8a6i_6eu0b_219",
  "list-grid-8": "awsui_list-grid-8_p8a6i_6eu0b_222",
  "list-grid-9": "awsui_list-grid-9_p8a6i_6eu0b_225",
  "list-grid-10": "awsui_list-grid-10_p8a6i_6eu0b_228",
  "list-grid-11": "awsui_list-grid-11_p8a6i_6eu0b_231",
  "list-grid-12": "awsui_list-grid-12_p8a6i_6eu0b_234",
  "list-grid-13": "awsui_list-grid-13_p8a6i_6eu0b_237",
  "list-grid-14": "awsui_list-grid-14_p8a6i_6eu0b_240",
  "list-grid-15": "awsui_list-grid-15_p8a6i_6eu0b_243",
  "list-grid-16": "awsui_list-grid-16_p8a6i_6eu0b_246",
  "list-grid-17": "awsui_list-grid-17_p8a6i_6eu0b_249",
  "list-grid-18": "awsui_list-grid-18_p8a6i_6eu0b_252",
  "list-grid-19": "awsui_list-grid-19_p8a6i_6eu0b_255",
  "list-grid-20": "awsui_list-grid-20_p8a6i_6eu0b_258",
  "selection-control": "awsui_selection-control_p8a6i_6eu0b_262",
  "loading": "awsui_loading_p8a6i_6eu0b_272",
  "empty": "awsui_empty_p8a6i_6eu0b_273",
  "has-header": "awsui_has-header_p8a6i_6eu0b_280",
  "refresh": "awsui_refresh_p8a6i_6eu0b_283",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_p8a6i_6eu0b_283",
  "card-header": "awsui_card-header_p8a6i_6eu0b_354",
  "card-header-inner": "awsui_card-header-inner_p8a6i_6eu0b_362",
  "card-selectable": "awsui_card-selectable_p8a6i_6eu0b_366",
  "card-selected": "awsui_card-selected_p8a6i_6eu0b_369",
  "section": "awsui_section_p8a6i_6eu0b_377",
  "section-header": "awsui_section-header_p8a6i_6eu0b_385",
  "section-content": "awsui_section-content_p8a6i_6eu0b_391",
  "footer-pagination": "awsui_footer-pagination_p8a6i_6eu0b_401"
};
  